"use strict";
exports.__esModule = true;
exports.NOOP = function () {
    return;
};
function generateUEID() {
    var first = Math.round(Math.random() * 46656);
    var second = Math.round(Math.random() * 46656);
    first = ("000" + first.toString(36)).slice(-3);
    second = ("000" + second.toString(36)).slice(-3);
    return first + second;
}
exports.generateUEID = generateUEID;
